import React, { useEffect, useState } from "react";
import {
  addProject,
  deleteProject,
  getProjects,
  updateProject,
} from "../../api/ProjectApi";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import { appTitle } from "../common/GeneralConfigurations";
import ProjectForm from "./ProjectForm";
import ProjectListForm from "./ProjectListForm";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../AppRoutes";

function ManageProjectListPage() {
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState("add");
  const [visible, setVisible] = useState(false);
  const [projectData, setProjectData] = useState([])
  const [projectHandler, setProjectHandler] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    document.title = `${appTitle} - Projects`;
    getProjectData();
  }, []);

  const getProjectData = () => {
    getProjects().then((res) => {
      if (res.status == 200 && res.data.result) {
        setProjectData(res.data.result.map(p => {
          p.typeName = p.typeName.replace(/([A-Z])/g, ' $1').trim()
          return p
        }));
        setLoading(false);
      } else {
        AdnMessageError();
        setLoading(false);
      }
    });
  };

  const deleteProjectData = (id) => {
    deleteProject(id).then((res) => {
      if (res.status == 200) {
        getProjectData();
        AdnMessageSuccess();
      } else {
        AdnMessageError();
      }
    });
  };
  const addProject = () => {
    navigate(AppRoutes.project.path);
  };

  return (
    <ProjectListForm
      projectData={projectData}
      loading={loading}
      event={event}
      setEvent={setEvent}
      visible={visible}
      setVisible={setVisible}
      setProjectHandler={setProjectHandler}
      addProject={addProject}
      deleteProjectData={deleteProjectData}
    />
  );
}

export default ManageProjectListPage;
